import { memo } from 'react';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import Confetti from 'react-confetti';
import { Cup, CupSize, CupVariant } from 'root/src/client/web/giveaway/components/Cup';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import { RedeemModal } from 'root/src/client/web/giveaway/features/RedeemModal/RedeemModal';
export const GiveawayWonModal = memo(() => {
    const modal = useModal();
    return (<ModalLayout>
			<div className="absolute left-0 top-0 z-0 w-full h-full overflow-hidden">
				<Confetti numberOfPieces={100}/>
			</div>
			<h1 className="font-bold text-2xl font-mono">Congratulations!</h1>
			<Cup size={CupSize.XL} variant={CupVariant.Gold}/>
			<p className="text-teal font-bold">You have won the Giveaway!</p>
			<ButtonNew type="button" onClick={() => {
            modal.show(<RedeemModal />);
        }}>
				Select Reward
			</ButtonNew>
		</ModalLayout>);
});
